/**
 * Einwilligungsabhängige Ereignis-Meldungen an den bestehenden Tag Manager.
 *
 * Es wird kein zweites Messwerkzeug eingeführt: Ereignisse landen im
 * vorhandenen `dataLayer`, den der Consent-Provider ohnehin aufbaut. Gesendet
 * wird ausschließlich, wenn die Einwilligung für Statistik vorliegt.
 */
import { loadConsent } from "@/lib/consent/storage";

export type TrackedEvent =
  | "verteiler_karte"
  | "terminbuchung_kopfbereich"
  | "terminbuchung_abschluss"
  | "verweis_nicht_wahlkampf"
  /** Ticket W14: Klick auf den Freebie-Abschnitt einer Produktseite. */
  | "freebie_karte";

export function pushTrackedEvent(
  event: TrackedEvent,
  params: Record<string, string> = {},
): void {
  if (typeof window === "undefined") return;
  const consent = loadConsent();
  if (!consent?.categories.statistics) return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch {
    /* Messung darf die Seite nie blockieren */
  }
}
